import script from "./Signconting.vue?vue&type=script&lang=ts&setup=true"
export * from "./Signconting.vue?vue&type=script&lang=ts&setup=true"

import "./Signconting.vue?vue&type=style&index=0&id=3f4c6f1a&scoped=true&lang=less"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f4c6f1a"]])

export default __exports__